export default "__VITE_ASSET__zcEMiya6__"